// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3R6O1","right":"styles_right__2CV4_"};